module.exports = __webpack_public_path__ + "img/bmgjlogo.a856d4e5.png";